

document.addEventListener('DOMContentLoaded', () => {
  const productForms = document.querySelectorAll('.product-card-form');

  productForms.forEach(form => {
    const minusBtn = form.querySelector('.quantity-btn.minus');
    const plusBtn = form.querySelector('.quantity-btn.plus');
    const qtyInput = form.querySelector('.quantity-input');

    if (!qtyInput) return;

    minusBtn?.addEventListener('click', () => {
      let qty = parseInt(qtyInput.value) || 1;
      qtyInput.value = Math.max(1, qty - 1);
    });

    plusBtn?.addEventListener('click', () => {
      let qty = parseInt(qtyInput.value) || 1;
      qtyInput.value = qty + 1;
    });
  });

  document.addEventListener('product-form:submit', async (event) => {
    const form = event.target.closest('.product-card-form');
    if (!form) return;
    event.preventDefault();

    const formData = new FormData(form);
    const data = {
      id: formData.get('id'),
      quantity: parseInt(formData.get('quantity')) || 1
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        throw new Error('Erro ao adicionar ao carrinho')
      }

      const cartDrawerToggle = document.querySelector('[data-cart-toggle]');
      if(cartDrawerToggle) {
        cartDrawerToggle.click();
      } else {
        document.dispatchEvent(new Event('cart:refresh'));
      }

    } catch (error) {
      console.error('Erro ao adicionar ao carrinho:', error);
    }
  });
});
